<div class=" fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div class="bg-white rounded-xl shadow-2xl w-full max-w-sm mx-auto p-6">
        <!-- Success Icon -->
        <div class="flex justify-center mb-4">
            <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                <svg class="w-8 h-8 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clip-rule="evenodd"></path>
                </svg>
            </div>
        </div>

        <div class="text-center mb-6">
            <h2 class="text-xl font-semibold text-gray-900 mb-2">Almost There!</h2>
            <p class="text-sm text-gray-600">Enter your organization ID to access your portal</p>
        </div>

        <form class="space-y-4">
            <div>
                <input [(ngModel)]="organizationNumber" type="text" name="organizationNumber"
                    placeholder="Organization ID"
                    class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all"
                    required>
            </div>

            <button (click)="save()" type="submit"
                class="w-full bg-secondary text-white py-3 px-4 rounded-lg font-medium hover:bg-primary focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 transition-colors">
                {{message.isLoading ? 'Loading...':' Enter Portal'}}
            </button>
        </form>

        @if (message.message?.length ) {

        <div class="p-1 px-2 text-[14px] rounded-lg bg-red-100 text-red-600">
            {{message.message}}
        </div>
        }

        <div class="text-center mt-4">
            <button class="text-sm text-gray-500 hover:text-gray-700 transition-colors">
                Need help finding your Organization ID?
            </button>
        </div>
    </div>
</div>